import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

declare var google: any;

@Component({
  selector: 'app-map-dialog',
  templateUrl: './map-dialog.component.html',
  styleUrls: ['./map-dialog.component.scss']
})
export class MapDialogComponent implements OnInit, AfterViewInit {
  lat: number;
  lng: number;
  lat1: number;
  lng1: number;
  lat2: number;
  lng2: number;

  isService = false;
  OrderId: any;
  VehicleNumber: any;

  isMapReady = false;

  constructor(
    public dialogRef: MatDialogRef<MapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      if (this.data['isService'] === true) {
        this.isService = true;
        this.VehicleNumber = this.data['vehiclenumber'];
        this.OrderId = this.data['orderid'];
      }

      if (this.data['data']['Latitude'] != null && this.data['data']['Longitude'] != null) {
        this.lat = Number(this.data['data']['Latitude']);
        this.lng = Number(this.data['data']['Longitude']);
      }

      if (this.data['data']['Latitude1'] != null && this.data['data']['Longitude1'] != null) {
        this.lat1 = Number(this.data['data']['Latitude1']);
        this.lng1 = Number(this.data['data']['Longitude1']);
      }

      if (this.data['data']['Latitude2'] != null && this.data['data']['Longitude2'] != null) {
        this.lat2 = Number(this.data['data']['Latitude2']);
        this.lng2 = Number(this.data['data']['Longitude2']);
      }
    }
  }

  ngAfterViewInit(): void {
    // Delay setting map ready flag to avoid "IntersectionObserver" error
    setTimeout(() => {
      this.isMapReady = true;
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  onMapReady($event): void {
    let trafficLayer = new google.maps.TrafficLayer();
    trafficLayer.setMap($event);
  }
}
